import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { CustomerOrdersItem } from "../Item/CustomerOrdersItem"
import { StyledP } from "../../../Styled/Text"

const styles = {
  column: {
    widths: {
      "w-full": tw`w-full`,
      "w-1/8": tw`w-1/8`,
      "w-1/4": tw`w-1/4`,
    },
  },
}

const Wrapper = tw.div`w-full border-b border-dark`
const Header = tw.div`hidden md:block w-full pb-3-2`
const StyledRow = tw.div`flex items-center flex-wrap`
const StyledColumn = styled.div`
  ${({ width }) => (width && styles.column.widths[width] ? styles.column.widths[width] : null)}
`
const Label = tw.div`uppercase` // styledsmall

export const CustomerOrdersList = ({
  orders,
  loading,
  error,
  additionalOrderNo,
  additionalDate,
  additionalStatus,
  additionalTotalPrice,
  additionalMore,
}): JSX.Element => (
  <Wrapper>
    <Header>
      <StyledRow>
        <StyledColumn width={"w-1/8"}>
          <Label className="body_small_highlight">{additionalOrderNo}</Label>
        </StyledColumn>
        <StyledColumn width={"w-1/4"}>
          <Label className="body_small_highlight">{additionalDate}</Label>
        </StyledColumn>
        <StyledColumn width={"w-1/4"}>
          <Label className="body_small_highlight">{additionalStatus}</Label>
        </StyledColumn>
        <StyledColumn width={"w-1/4"}>
          <Label className="body_small_highlight">{additionalTotalPrice}</Label>
        </StyledColumn>
        <StyledColumn width={"w-1/8"}>
          <Label className="body_small_highlight">{additionalMore}</Label>
        </StyledColumn>
      </StyledRow>
    </Header>
    {!loading && orders?.length ? (
      orders?.map(order => <CustomerOrdersItem key={order?.name?.toString()} order={order} />)
    ) : (
      <StyledP>{`No orders`}</StyledP>
    )}
    {error && <StyledP>{`Error loading orders`}</StyledP>}
  </Wrapper>
)
